module.exports = __webpack_public_path__ + "static/media/10n.a0740249.png";